export const DEFAULT_VISIBLE_FACET_VALUES = 11;

export const TREE_NSDI_SECTION_ID = 'tree_nsdi';
